import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Home from './views/Home.vue'  // Add Home component import
import './assets/css/public.css'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Home }, // Now using imported component
  ]
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
